var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.logsData),function(log,index){return _c('Row',{key:((log.date) + "-" + index),staticClass:"log-row",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('Col',{attrs:{"span":"10"}},[_vm._v(_vm._s(log.date))]),_vm._v(" "),_c('Col',{attrs:{"span":"14"}},[_vm._v(_vm._s(log.detail))])],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-694e5de0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/pages/cleaner/order-list/order-logs.vue
// module id = ioG4
// module chunks = 0